import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { ArticleContext } from '~/contexts/ArticleContext';
import VideoPlayerEmbed from '~/components/Shared/Video/VideoPlayerEmbed';
import { shouldUseVideoPlayerAsCover } from '~/utilities/experiments/videoPlacement';
import { hasFanSidedVideo } from '~/utilities/experiments/fanSidedVideoAds';
import { AppDataContext } from '~/contexts/AppDataContext';
import ArticleCoverImage from '~/components/Layout/Body/Article/ArticleCover/ArticleCoverImage';
import VideoPlayer from '~/components/Shared/Video/VideoPlayer';

export default component$((): JSX.Element => {
  const article = useContext(ArticleContext);
  const { payloadToSSR, property } = useContext(AppDataContext);
  const { experiments, isMobileViewer } = payloadToSSR;

  if (!article || !article.cover) return <></>;

  // TODO: Remove once the video placement experiment ends.
  if (
    shouldUseVideoPlayerAsCover(article, isMobileViewer ?? false, experiments)
  ) {
    return (
      <div class='absolute top-0 left-0 w-full'>
        <VideoPlayer
          sizes={isMobileViewer ? ['sm', 'md'] : ['lg']}
          mediaValue={undefined}
        />
      </div>
    );
  }

  const mediaType = article.cover.media?.type;
  const mediaValue = article.cover.media?.value;

  if (!mediaType || !mediaValue) return <></>;

  if (!hasFanSidedVideo(property)) {
    return <ArticleCoverImage />;
  }

  if (mediaType === 'youtube' && mediaValue.html) {
    return (
      <div class='absolute top-0 left-0 w-full'>
        <figure
          class='relative aspect-video overflow-hidden max-w-full bg-black [&>iframe]:absolute [&>iframe]:top-0 [&>iframe]:left-0 [&>iframe]:w-full [&>iframe]:h-full [&>iframe]:border-0'
          dangerouslySetInnerHTML={mediaValue.html}
        />
      </div>
    );
  }

  if (mediaType === 'mmPlayer') {
    return (
      <div class='absolute top-0 left-0 w-full'>
        <VideoPlayerEmbed html={mediaValue.html} version={mediaValue.version} />
      </div>
    );
  }

  return <></>;
});
